import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

/**
 * usePollingAvailability Hook
 * Checks which stores have polling data available
 * Returns an object where storeId: true/false indicating polling availability
 */
export const usePollingAvailability = (storeIds) => {
  const [pollingAvailability, setPollingAvailability] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const checkPollingAvailability = useCallback(async () => {
    if (!storeIds || storeIds.length === 0) {
      setPollingAvailability({});
      return;
    }

    setIsLoading(true);
    const availability = {};

    try {
      // Check each store for polling data
      await Promise.all(
        storeIds.map(async (storeId) => {
          try {
            const response = await api.get(`/polls/store/${storeId}/analytics`);
            const hasPolls = response.data?.data?.polls && response.data.data.polls.length > 0;
            availability[storeId] = hasPolls; // true if has polling data
            console.log(`📊 Store ${storeId} polling availability: ${hasPolls}`);
          } catch (error) {
            availability[storeId] = false; // false if error
            console.warn(`⚠️ Error checking polling availability for ${storeId}:`, error.message);
          }
        })
      );

      setPollingAvailability(availability);
      console.log('🔍 Polling availability check complete:', availability);
    } catch (error) {
      console.error('❌ Error checking polling availability:', error);
    } finally {
      setIsLoading(false);
    }
  }, [storeIds]);

  useEffect(() => {
    checkPollingAvailability();
  }, [checkPollingAvailability]);

  return {
    pollingAvailability,
    isLoading,
    refresh: checkPollingAvailability
  };
};

export default usePollingAvailability;
